import { useIsAuthenticated } from '@azure/msal-react';
import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { IconLogin, IconLogout } from '@tabler/icons-react';
import { type LoginRequest } from './acquireToken';
import { useLogin, useLogout } from './useLoginLogout';

interface IProps {
    loginRequest: LoginRequest;
    minimal?: boolean;
}

// @ai-generated 2026-10-29T11:39:36+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** A button that signs the user in, or out when they already are. `minimal` shows the icon only. */
export function LoginButton({ loginRequest, minimal }: IProps) {
    const login = useLogin(loginRequest);
    const logout = useLogout();
    const isLoggedIn = useIsAuthenticated();

    if (isLoggedIn) {
        return (
            <Button label="btnLogout" onClick={logout} appearance={minimal ? 'transparent' : 'filled'}>
                <IconLogout size={defaultIconSize} />
                &nbsp;{minimal ? '' : 'Abmelden'}
            </Button>
        );
    } else {
        return (
            <Button label="btnLogin" onClick={login} appearance={minimal ? 'transparent' : 'filled'}>
                <IconLogin size={defaultIconSize} />
                &nbsp;{minimal ? '' : 'Anmelden'}
            </Button>
        );
    }
}
